import { defineStore } from "pinia";
import { setLocalData, getLocalData } from "@utils";
import {
  loginApi,
  loginOutApi,
  getUserInfoApi,
  getSysMenuListApi,
  SendCaptchaCodeApi,
  ChangePasswordApi,
  updateColumnsApi,
  getColumnsInfoApi,
} from "@/config/api";
import { CollectionsFilled } from "@vicons/material";

const INIT_TOKEN = {
  access_token: "",
  token_type: "",
  refresh_token: "",
  expires_in: 0,
  scope: "",
};
const INIT_USERS = {
  authorities: [],
  id: undefined,
  name: "",
  role_id: "",
  role_name: "",
};
const INIT_PERMISSIONS = {
  source: [],
  codeList: [],
};
const INIT_USERACCOUNT = {
  username: "",
  password: "",
};

const menu_list = [
  "ask-tool:project-page",
  "ask-tool:program-list",
  "settlement_process:page",
  "ask-tool:proof",
  "auto-screen-task:page",
  "auto-screen-project:page",
  "auto-screen-preview-task:page",
  "autoscreen-config:page",
  "desktop-config:page",
  "autoscreen-mediaresource:page",
  "autoscreen-advertiserconfig:page",
  "click-template:page",
  "autoscreen-parameterconfig:page",
  "autoscreen-requireconfig:page",
  "project-report:page",
  "dashboard-report:export-page",
  "user:page",
  "role:page",
  "order-company:page",
  "advertiserManage:list",
  "company:list"
]

const INIT_STATE = {
  users: getLocalData("users") || INIT_USERS,
  tokenData: getLocalData("token-data") || INIT_TOKEN,
  permissionsData: getLocalData("permissions-data") || INIT_PERMISSIONS,
  isRemove: false,
  isMobile: window.screen.width > 320 && window.screen.width < 960,
  account: getLocalData("account") || INIT_USERACCOUNT,
  bread: [],
  sysDictCache: null, // 厂商字典缓存
  project: {
    isOperate: true,
  },
  screenTemplate: {
    isOperate: true,
  },
  orderData: {
    isOperate: true,
  },
  user: {
    isOperate: true,
  },
  role: {
    isOperate: true,
  },
  order: {
    isOperate: true,
  },
  orderChangeTake: {
    isOperate: true,
  },
  projectChangeTake: {
    isOperate: true,
  },
  industryManage: {
    isOperate: true,
  },
  advertisers: {
    isOperate: true,
  },
  projectReport: {
    isOperate: true,
  },
  agentCompany: {
    isOperate: true,
  },
  sceneParameterCpmfogiration: {
    isOperate: true,
  },
  screenRecordingRequirementsConfiguration: {
    isOperate: true,
  },
  advertiserConfiguration: {
    isOperate: true,
  },
  screenPreviewTask: {
    isOperate: true,
  },
  screenCommonTask: {
    isOperate: true,
  },
  largeMarket: {
    isOperate: true,
  },
  downloadCenter: {
    isOperate: true,
  },
  uploadMenu: false,
  /** 从 addInquiries / addSchedulingLInfo / addSchedulingList 离开时，是否因“有未保存修改”而需弹窗 */
  routeFormDirty: {
    addInquiries: false,
    addSchedulingLInfo: false,
    addSchedulingList: false,
  },
};
const useStore: any = defineStore("storeData", {
  state: () => {
    return INIT_STATE;
  },
  actions: {
    /**
     * 根据token 刷新用户信息
     */
    async refreshUserInfo() {
      let res = await getUserInfoApi();
      if (res.code == 200) {
        this.users = res.data;
        await setLocalData("users", res.data);
        return res.data;
      }
    },
    /**
     * 触发菜单更新
     */
    updateMenu() {
      this.uploadMenu = true;
    },
    /**
     * 获取所有权限集合
     */
    async getSysMenuList() {
      let { data } = await getSysMenuListApi();
      this.permissionsData.source = data;
      this.permissionsData.codeList = data.map((item: { perms: any; }) => {
        return item.perms;
      });
      await setLocalData("permissions-data", this.permissionsData);
      return data;
    },
    /**
     * 登录
     * @param params
     */
    async login(params: any) {
      //先请求
      let { data } = await loginApi(params);
      this.tokenData = data;
      await setLocalData("token-data", this.tokenData);
      //刷新用户信息
      await this.refreshUserInfo();
      await this.getSysMenuList();
    },
    loginOut() {
      this.isRemove = true;
      loginOutApi().then((res) => {
        // localStorage.clear()
        localStorage.removeItem("users");
        localStorage.removeItem("token-data");
        localStorage.removeItem("permissions-data");
        this.$reset();
        this.isRemove = false;
      });
    },
    rememberPassword(params: any) {
      setLocalData("account", params);
    },
    unRememberPassword() {
      localStorage.removeItem("account");
    },
    /**
     * 发送验证码
     */
    async CaptchaCode(email: string) {
      try {
        let captcha = await SendCaptchaCodeApi(email);
        return captcha.code;
      } catch (res) {
        console.error(res);
      }
    },
    /**
     * 重置密码
     */
    async ChangePassword(params: any) {
      try {
        let changePassword = await ChangePasswordApi(params);
        return changePassword.code;
      } catch (res) {
        console.error(res);
      }
    },
    /**
     * 自定义列保存
     */
    async CustomAdd(params: any) {
      await updateColumnsApi(params);
      return true;
    },
    /**
     * 自定义列、页面操作查询
     */
    async GetCustomPageInfo(params: any) {
      return getColumnsInfoApi(params);
    },
    /**
     * 设置指定路由页面的“表单是否有修改”（用于离开时是否弹窗）
     * @param routeName 路由 name：addInquiries | addSchedulingLInfo | addSchedulingList
     * @param dirty 是否有修改
     */
    setRouteFormDirty(routeName: "addInquiries" | "addSchedulingLInfo" | "addSchedulingList", dirty: boolean) {
      this.routeFormDirty[routeName] = dirty;
    },
  },

  getters: {
    getPower: (state: any) => (id: string[] | string) => {
      // 优先从 authorities 中判断
      let codeList = state.users.authorities || [];

      // 如果 authorities 为空，从 permissionsData.codeList 中判断
      if (!codeList.length && state.permissionsData && state.permissionsData.codeList) {
        codeList = state.permissionsData.codeList;
      }

      if (codeList.length <= 0) {
        return false;
      }
      if (Array.isArray(id)) {
        return id.some(function (item: string) {
          return codeList.includes(item);
        });
      } else {
        return codeList.includes(id);
      }
    },
    /**
     * 获取用户信息
     */
    getUserInfo: (state: any) => {
      return { ...state.users, ...state.tokenData };
    },
    updateUser: (state: any) => (user: any) => {
      if (user.name) {
        state.users.name = user.name;
      }
      if (user.authorities) {
        state.users.authorities = user.authorities;
      }
      if (user.role_name) {
        state.users.role_name = user.role_name;
      }
      if (user.role_id) {
        state.users.role_id = user.role_id;
      }

      setLocalData("users", state.users);
      state.uploadMenu = true;
    },
  },
});

export default useStore;
